import { render, staticRenderFns } from "./PosSelector.vue?vue&type=template&id=0006d2b8&scoped=true"
import script from "./PosSelector.vue?vue&type=script&lang=js"
export * from "./PosSelector.vue?vue&type=script&lang=js"
import style0 from "./PosSelector.vue?vue&type=style&index=0&id=0006d2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0006d2b8",
  null
  
)

export default component.exports